<mat-toolbar class="white-bg">
  <span style="flex: 1 1 auto; font-size: 14px">&#169; Vendasta</span>
  <mat-nav-list class="nav-list">
    <a mat-nav-list-item href="https://vendasta.com/terms/terms-of-use">Terms of Use</a>
    <a mat-nav-list-item href="https://vendasta.com//privacy-policy">Privacy Policy</a>
  </mat-nav-list>
</mat-toolbar>
